import { ICoordinate } from '../../support/model/ICoordinate';
import { formatCoordinates } from '../../support/helpers/format';

export const Coordinates: React.FC<{coordinates?: ICoordinate}> = ({ coordinates }) => {
    const output = coordinates ? formatCoordinates(coordinates) : '';
    return <span>{output}</span>;
};
